import { Experiment } from "@amplitude/experiment-js-client"

import type { InitializeExperimentSDK } from "./types"

export const initialize: InitializeExperimentSDK = (sdkKey, config) => Experiment.initialize(sdkKey, config)
